import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../databaseServices/BaseDatabaseService';

@Injectable({
  providedIn: 'root'
})
export class VarSymService extends BaseDatabaseService{

  private static MAX = 10000;

  private collectionName = 'varSym';

  constructor() {
    super();
  }

  public getAllVarSym() {
    return this.db.collection(this.collectionName).doc('last').get();
  }

  public saveVarSym(symbol) {
    symbol = symbol + 1;
    symbol = symbol === 0 ? 1 : symbol;
    const obj = {
      'varSym': symbol
    };
    return this.db.collection(this.collectionName).doc('last').set(obj);
  }


}
